module.exports = __webpack_public_path__ + "static/a-brief-history-of-seven-killings-8aadeadd70299cb795c9149cf118d98e.jpg";